// Quack! This is a duck. https://github.com/erikras/ducks-modular-redux
import { makeReducer } from '../../core/make-reducer';
import { makeActionCreators } from '../../core/make-action-creators';
import * as API from '../../core/api';

export const actions = {
  REQUEST: 'Dora/user-events/REQUEST',
  RECEIVE: 'Dora/user-events/SUCCESS',
  FAIL: 'Dora/user-events/FAIL',
};

export default makeReducer({ actions });

const actionCreators = makeActionCreators({
  reducerName: 'userEvents',
  actions,
  requestDataCall: (store, params) => API.get('events/mine', params),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/updates/user-updates/duck.js